import { EmptyState } from "@hightouch/htui";
import { MediaDetailHeader } from "src/components/media-detail";

type AdNotFoundProps = { heading: string };

export const AdNotFound = ({ heading }: AdNotFoundProps) => (
  <>
    <MediaDetailHeader title={heading} />
    <EmptyState
      variant="minimal"
      title="Ad not found"
      message="This ad has no data for the selected date range."
    />
  </>
);
